import { cosemApi } from '@services/providers/cosem';
import { PriceType, PriceTypeToCreate, PriceTypeToUpdate } from './price-types.types';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';

const priceTypesApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getPriceTypes: build.mutation<ApiResponse<PriceType[]>, void>({
            query: () => {
                return {
                    url: `/member/price-types`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<PriceType[]>) => response
        }),
        getPaginatedPriceTypes: build.mutation<
            ApiPaginationResponse<PriceType>,
            { limit?: number; page?: number; search?: string; orderBy?: string }
        >({
            query: ({ limit = 10, page = 1, search, orderBy }) => {
                return {
                    url: `/member/price-types/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '' }
                };
            },
            transformResponse: (response: ApiPaginationResponse<PriceType>) => response
        }),
        getArchivedPaginatedPriceTypes: build.mutation<
            ApiPaginationResponse<PriceType>,
            { limit?: number; page?: number; search?: string; orderBy?: string }
        >({
            query: ({ limit = 10, page = 1, search, orderBy }) => {
                return {
                    url: `/member/price-types/archived/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '' }
                };
            },
            transformResponse: (response: ApiPaginationResponse<PriceType>) => response
        }),
        updatePriceType: build.mutation<ApiResponse<PriceType>, PriceTypeToUpdate>({
            query: (priceType: PriceTypeToUpdate) => {
                return {
                    url: `/member/price-types/${priceType.id}`,
                    method: 'PUT',
                    body: priceType
                };
            },
            transformResponse: (response: ApiResponse<PriceType>) => response
        }),
        createPriceType: build.mutation<ApiResponse<PriceType>, PriceTypeToCreate>({
            query: (priceType: PriceTypeToCreate) => {
                return {
                    url: `/member/price-types`,
                    method: 'POST',
                    body: priceType
                };
            },
            transformResponse: (response: ApiResponse<PriceType>) => response
        }),
        deletePriceType: build.mutation<ApiResponse<PriceType>, { id: string }>({
            query: ({ id }) => {
                return {
                    url: `/member/price-types/${id}`,
                    method: 'DELETE'
                };
            },
            transformResponse: (response: ApiResponse<PriceType>) => response
        }),
        toggleArchivePriceType: build.mutation<ApiResponse<PriceType>, { id: string|number, archived: boolean }>({
            query: ({ id, archived }) => {
                return { 
                    url: `/member/price-types/${id}/archive`, 
                    method: 'PUT',
                    body: { archived }
                };
            },
            transformResponse: (response: ApiResponse<PriceType>) => response
        }),
    })
});

export const {
    useGetPriceTypesMutation,
    useGetPaginatedPriceTypesMutation,
    useGetArchivedPaginatedPriceTypesMutation,
    useUpdatePriceTypeMutation,
    useCreatePriceTypeMutation,
    useDeletePriceTypeMutation,
    useToggleArchivePriceTypeMutation
} = priceTypesApi;
